import React, { createContext, useContext, useState } from "react";

interface ManagerModalContextType {
    isOpen: boolean;
    openManagerModal: () => void;
    closeManagerModal: () => void;
}

const ManagerModalContext = createContext<ManagerModalContextType | undefined>(
    undefined
);

export const ManagerModalProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const openManagerModal = () => {
        console.log("Opening Manager Modal");
        setIsOpen(true);
    };

    const closeManagerModal = () => setIsOpen(false);

    return (
        <ManagerModalContext.Provider
            value={{ isOpen, openManagerModal, closeManagerModal }}
        >
            {children}
        </ManagerModalContext.Provider>
    );
};

export const useManagerModal = () => {
    const context = useContext(ManagerModalContext);
    if (!context) {
        throw new Error(
            "useManagerModal must be used within ManagerModalProvider"
        );
    }
    return context;
};
